export const API_URL = `https://sop-procurement.undp.org.rs/api`;
